import DigitalAssetModel from '../../generated/types/model/resource/DigitalAssetModel';

export default class DigitalAssetViewModel extends DigitalAssetModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
